// The OAuth `state` every identity-started provider flow sends (Google,
// LinkedIn, Microsoft, Apple). `nonce` binds the flow to the browser that
// started it: the login/signup loader sets the same value in an HttpOnly
// cookie and the callback refuses unless the two match (FOX-4690). Shared by
// both pages and every provider so the format cannot drift between them.
export type OAuthState = {
  redirectUrl: string;
  inviteCode: string;
  nonce: string;
};

export function encodeOAuthState(state: OAuthState): string {
  return btoa(JSON.stringify(state));
}

// Apple's authorize URL, for both the popup and the Safari full-page path on
// both pages. The base64 state can contain `+`, which an unencoded query value
// turns into a space, so it is always encoded here.
export function appleAuthorizeUrl({
  clientId,
  redirectUri,
  state,
}: {
  clientId: string;
  redirectUri: string;
  state: string;
}): string {
  return `https://appleid.apple.com/auth/authorize?scope=email%20name&response_mode=form_post&response_type=code&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}&state=${encodeURIComponent(state)}&client_id=${encodeURIComponent(clientId)}`;
}
